import { gql } from "apollo-boost";

export const CREATE_CUSTOMER = gql`
  mutation consumerCreateCustomer($customer: ConsumerCustomerInput!) {
    consumerCreateCustomer(customer: $customer) {
      id
      firstName
      middleName
      lastName
      phoneNumber {
        phone
        country
      }
      email
      location {
        fullAddress
        city
        country
        state
        zipcode
        street
      }
      license {
        licenseNumber
        dateOfExpiry
        authority
        images
      }
      identityVerification {
        provider
        applicantId
        workflowRunId
        status
      }
    }
  }
`;

export const CHECK_LICENSE_NUMBER = gql`
  query consumerCheckLicenseNumber($licenseNumber: String!) {
    consumerCheckLicenseNumber(licenseNumber: $licenseNumber) {
      exists
      message
    }
  }
`;

export const ADD_NEW_DRIVERS = gql`
  mutation consumerAddDrivers(
    $customerId: String!
    $drivers: [NewDriverCustomerInput]!
  ) {
    consumerAddDrivers(customerId: $customerId, drivers: $drivers) {
      id
      firstName
      lastName
      email
      phoneNumber {
        phone
        country
      }
      license {
        licenseNumber
        dateOfExpiry
        authority
        images
      }
    }
  }
`;
